import type { ChamberViewerTourStop } from './chamberViewerTourConfig';
import {
  ChamberViewerTourStops,
  chamberViewerTour,
} from './chamberViewerTourConfig';
import { createTourContext } from './tourContextBase';
import type { ReactNode } from 'react';

export const CHAMBER_VIEWER_TOUR_LOCAL_STORAGE_KEY =
  'pd_chamber_viewer_tour_stops_taken';
export const CHAMBER_VIEWER_TOUR_ID = 'ChamberViewerTourContext';

const {
  Context: ChamberViewerTourContext,
  useTourStop: useChamberViewerTourStopBase,
  useTour: useChamberViewerTourBase,
  TourProvider: ChamberViewerTourProviderBase,
} = createTourContext<ChamberViewerTourStop, ChamberViewerTourStops>();

export { ChamberViewerTourContext };

/**
 * Returns the current stop and ref if the
 * tourStop param matches the current stop.
 */
export const useChamberViewerTourStop = useChamberViewerTourStopBase;

/**
 * Returns the chamber viewer tour context.
 */
export const useChamberViewerTour = () =>
  useChamberViewerTourBase('ChamberViewerTourContext');

const ChamberViewerTourProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ChamberViewerTourProviderBase
      config={{
        tour: chamberViewerTour,
        localStorageKey: CHAMBER_VIEWER_TOUR_LOCAL_STORAGE_KEY,
        contextName: CHAMBER_VIEWER_TOUR_ID,
        showInGlobalHelp: false,
        legacyCompletionStopIds: [
          ChamberViewerTourStops.STEP_1,
          ChamberViewerTourStops.STEP_2,
          ChamberViewerTourStops.STEP_3,
        ],
      }}
    >
      {children}
    </ChamberViewerTourProviderBase>
  );
};

export default ChamberViewerTourProvider;
